import { ParsedUrlQuery } from 'querystring';

export const makeFilterParam = (
  filterFormatters: { [key: string]: (value: string) => string },
  firstClause: string,
  restOfQuery: ParsedUrlQuery
) =>
  [firstClause]
    .concat(
      Object.keys(filterFormatters).reduce(
        (a, key) =>
          a.concat(
            toArray(restOfQuery[key])
              .map(filterFormatters[key])
              .join(' or ') || []
          ),
        [] as string[]
      )
    )
    .map((clause: string) => `(${clause})`)
    .join(' and ');

export const makeSkipParam = (page: ParsedUrlQuery[string] | undefined, $top: number) =>
  page && (parseInt(page.toString(), 10) - 1) * $top;

const toArray = (values?: string | string[]) => (values ? (typeof values === 'string' ? [values] : values) : []);
